import { z } from '@bonanza-social/toolkit/api';

export const FavoriteSchema = z.object({}).optional();

export const UnfavoriteSchema = z.object({}).optional();
